let compMap = {
  0: {
    label: '未知服务器类型',
    name: 'CONST_CCS_CT_Unknown_0'
  },
  1: {
    label: 'ICIP服务器配置管理中心',
    name: 'CONST_CCS_CT_Console_1'
  },
  2: {
    label: 'ICIP监控服务器',
    name: 'CONST_CCS_CT_Monitor_2'
  },
  3: {
    label: 'CCS服务器',
    name: 'CONST_CCS_CT_CCS_3'
  },
  4: {
    label: '即时通讯服务器',
    name: 'CONST_CCS_CT_IMS_4'
  },
  5: {
    label: 'E-mail服务器',
    name: 'CONST_CCS_CT_EMS_5'
  },
  6: {
    label: 'E-短消息服务器',
    name: 'CONST_CCS_CT_SMS_6'
  },
  7: {
    label: '护航浏览服务器',
    name: 'CONST_CCS_CT_WBS_7'
  },
  8: {
    label: '话务媒体接入服务器',
    name: 'CONST_CCS_CT_TAS_8'
  },
  9: {
    label: '自动外呼服务器',
    name: 'CONST_CCS_CT_OBS_9'
  },
  10: {
    label: '交互式语音应答服务器',
    name: 'CONST_CCS_CT_IVR_10'
  },
  11: {
    label: '自动呼叫分配服务器',
    name: 'CONST_CCS_CT_ACD_11'
  },
  12: {
    label: '座席代理服务器',
    name: 'CONST_CCS_CT_AgentProxy_12'
  },
  13: {
    label: '传真服务器',
    name: 'CONST_CCS_CT_FaxServer_13'
  },
  14: {
    label: '面向应用的呼叫接口',
    name: 'CONST_CCS_CT_Call_14'
  },
  15: {
    label: 'TTS服务组件',
    name: 'CONST_CCS_CT_TTS_15'
  },
  16: {
    label: 'myhmp',
    name: 'CONST_CCS_CT_MYHMP_16'
  }
}
export default {
  showComponentName: (component) => {
    let libComponent = compMap[component]
    if (libComponent)
      return libComponent.name
    else
      return component.toString()
  }
} 